import React, { ReactNode, Suspense } from 'react';

import { DefaultFooter } from '@/app/_components/layout-content/FooterItems';
import { BrandResourceLogoHeader, LogoHeader, MainContainer } from '@/app/_components/layout-content/LayoutItems';

export function LogoLayout({ children = true, isBrandResource = false }: { children: ReactNode; isBrandResource?: boolean }) {
  return (
    <Suspense>
      {isBrandResource ? <BrandResourceLogoHeader /> : <LogoHeader />}
      <MainContainer>{children}</MainContainer>
      <DefaultFooter />
    </Suspense>
  );
}
